import { Accordion, AccordionItem } from "@heroui/accordion";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import {
  useCalculateExpectedScoreMutation,
  useCalculateKraScoreMutation,
  useCalculateMainScoreMutation,
  useGetManagementReviewQuery,
  useSaveHRKraMutation,
} from "../../../../api/employeeApi";
import {
  useGetHODScoreRecommwndationQuery,
  useManagementAppraisalReviewMutation,
  useManagementCommentMutation,
} from "../../../../api/hrApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import bull from "../../../assets/bull.png";
import flag from "../../../assets/finish-FLAG.png";
import person from "../../../assets/personAppraisal.png";
import PageLayout from "../../../Components/Layout/PageLayout";
import { Content1, MetaData } from "../../Employee/SelfAppraisal/data";
import ApproveModal from "../../HR/Appraisal/Modals/ApproveModal";
import { MeasurementTypeFormatter } from "../../HR/Appraisal/Modals/data";
import { AppraisalDeclineModal } from "../../HR/Appraisal/Modals/DeclineModal";
import AppraisalReviewDetails from "../../Employee/SelfAppraisal/reviewDetails";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { getMyPermissions } from "../../../../../utils/functions/GetMyPermissions";
import { FormProvider, useForm } from "react-hook-form";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import {
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../Components/Forms/InputTemplate";
const StandaloneCheckBox = ({
  camelCase,
  onChange,
  checked = false,
  ...props
}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={camelCase}
        name={camelCase}
        checked={checked}
        onChange={onChange}
        className="mr-2"
        {...props}
      />
    </div>
  );
};

export const ViewAppraisalManagementReview = () => {
  const { id } = useParams();
  const { data, refetch } = useGetManagementReviewQuery(id);
  const formMethods = useForm({
    mode: "all",
  });
  const { watch } = formMethods;
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;
  const [onSave, {}] = useSaveHRKraMutation();
  const [appraisalId, setAppraisalId] = useState();
  const [appraiseeId, setAppraiseeId] = useState();
  const allObjectives = data?.responseObject?.objectives || [];
  const employeeData = data?.responseObject?.employee;
  useEffect(() => {
    setAppraiseeId(employeeData?.id);
  }, [employeeData?.id]);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] =
    useManagementAppraisalReviewMutation();
  const { data: recommendation } = useGetHODScoreRecommwndationQuery({
    ApprovalStatus: 0,
    PageNumber: 1,
    PageSize: 1000,
  });
  const [makeComment, { isLoading: commentLoading }] =
    useManagementCommentMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);

  const [comment, setComment] = React.useState("");
  const [kraPerformanceScores, setKraPerformanceScores] = useState({});
  const [kraId, setKraId] = useState();
  const [KraIndex, setKraIndex] = useState();
  const [objIndex, setObjIndex] = useState();
  const [totalScore, setTotalScore] = useState({
    colorType: "",
    totalAppraisalScore: 0,
    performanceStatusLabelName: "",
  });
  const [maxScore, setMaxScore] = useState(0);
  const [item, setItem] = useState();
  const [score, setScore] = useState({
    actualValue: 0,
    targetValue: 0,
    weight: 0,
  });
  const initialized = React.useRef(false);
  const debounceRef = React.useRef(null);
  const debounceRefMain = React.useRef(null);
  const debounceExpected = React.useRef(null);
  const [isOverrideRecommendation, setIsOverrideRecommendation] =
    React.useState(false);
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === false) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        approvalType: type,
        appraisalId: appraisalId,
        isAccepted: type,
        comment,
        isOverrideRecommendation: isOverrideRecommendation,
        referenceId: id,
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/hr/management/Management-Appraisal");
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage ?? "Error approving rating scale");
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const [userPermissions, setUserPermissions] = useState([]);
  const [onCalculate] = useCalculateKraScoreMutation();
  const [expectedScore] = useCalculateExpectedScoreMutation();
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      return;
    }

    if (!allObjectives.length) return;
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(async () => {
      try {
        const objectives = allObjectives.map((objective) => {
          const krAs = objective.krAs.map((kra) => {
            const actualScore =
              kra?.employeeReviewDetails?.find(
                (item) => item.appraisalType === 1
              )?.kraActualScore || 0;
            return {
              kraId: kra.kraId,
              actualValue: parseInt(actualScore) || 0,
              targetValue: kra.targetValue || 0.01,
              weight: kra.weight,
            };
          });
          return {
            objectiveId: objective.objectiveId,
            objectiveWeight: objective.objectiveWeight,
            krAs,
          };
        });

        const res = await onCalculate({
          employeeId: employeeData?.id || 0,
          referenceId: id,
          objectives,
        }).unwrap();
        if (res) {
          setTotalScore({
            colorType: res.colorType,
            totalAppraisalScore: res.totalAppraisalScore,
            performanceStatusLabelName: res.performanceStatusLabelName,
          });
        }
      } catch (err) {
        console.error("Error calculating total actual score:", err);
      }
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [employeeData?.id, id, onCalculate, formMethods, allObjectives]);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      return;
    }

    if (!allObjectives.length) return;
    if (debounceExpected.current) {
      clearTimeout(debounceExpected.current);
    }
    debounceExpected.current = setTimeout(async () => {
      try {
        const objectives = allObjectives.map((objective) => {
          const krAs = objective.krAs.map((kra) => {
            return {
              kraId: kra.kraId,
              actualValue: kra.targetValue || 0,
              targetValue: kra.targetValue || 0,
              weight: kra.weight,
            };
          });
          return {
            objectiveId: objective.objectiveId,
            objectiveWeight: objective.objectiveWeight,
            krAs,
          };
        });

        const res = await expectedScore({
          employeeId: employeeData?.id || 0,
          referenceId: id,
          objectives,
        }).unwrap();
        if (res) {
          setMaxScore(res.totalAppraisalScore);
        }
      } catch (err) {
        console.error("Error calculating total actual score:", err);
      }
    }, 500);

    return () => {
      if (debounceExpected.current) {
        clearTimeout(debounceExpected.current);
      }
    };
  }, [employeeData?.id, id, expectedScore, formMethods, allObjectives]);
  const [onCalculateMainScore] = useCalculateMainScoreMutation();

  useEffect(() => {
    if (!score.actualValue && !score.targetValue && !score.weight) return;
    if (!item?.kraId) return;

    if (debounceRefMain.current) clearTimeout(debounceRefMain.current);

    debounceRefMain.current = setTimeout(async () => {
      try {
        const res = await onCalculateMainScore({
          actualValue: score.actualValue,
          targetValue: score.targetValue,
          weight: score.weight,
        }).unwrap();

        if (res) {
          setKraPerformanceScores((prev) => ({
            ...prev,
            [item.kraId]: res.kraPerformanceScore,
          }));
        }
      } catch (err) {
        console.error("Error calculating main score:", err);
      }
    }, 500);

    return () => {
      if (debounceRefMain.current) clearTimeout(debounceRefMain.current);
    };
  }, [score, onCalculateMainScore, item?.kraId]);
  useEffect(() => {
    setUserPermissions(getMyPermissions());
  }, []);
  const currentActualValue =
    objIndex !== undefined && KraIndex !== undefined
      ? watch(`KRAs_${objIndex}_${KraIndex}_actualScore`)
      : 0;
  useEffect(() => {
    if (item?.kraId && objIndex !== undefined && KraIndex !== undefined) {
      setScore({
        actualValue: parseFloat(currentActualValue) || 0,
        targetValue: item.targetValue,
        weight: item.weight,
      });
    }
  }, [item, KraIndex, objIndex, currentActualValue]);
  const isPermitted =
    userPermissions?.includes(DEFINED_PERMISSIONS.EDFinanceApprove) ||
    userPermissions?.includes(DEFINED_PERMISSIONS.MDApprove) ||
    userPermissions?.includes(DEFINED_PERMISSIONS.EDOperationApprove) ||
    userPermissions?.includes(DEFINED_PERMISSIONS.HOD);
  const user = GetLocalStorage();
  const getRoleFromDepartment = (departmentName) => {
    switch (departmentName) {
      case "Human Resources":
        return 3;
      case "ED Operations Office":
      case "ED F&I Office":
        return 4;
      case "MD Office":
        return 5;
      default:
        return null;
    }
  };
  const reviewerRole = getRoleFromDepartment(user?.departmentName);
  const handleSave = async () => {
    try {
      let foundObjIndex = -1;
      let foundKraIndex = -1;
      allObjectives?.forEach((objective, objIdx) => {
        objective.krAs?.forEach((kra, kraIdx) => {
          if (kra.kraId === kraId) {
            foundObjIndex = objIdx;
            foundKraIndex = kraIdx;
            // kraScore = kra.kraScore || 0;
          }
        });
      });

      if (foundObjIndex === -1 || foundKraIndex === -1) {
        toast.error("KRA not found");
        return;
      }

      const kraKey = `${foundObjIndex}_${foundKraIndex}`;
      const kraActualScore =
        formMethods.getValues(`KRAs_${kraKey}_actualScore`) || 0;
      const comment = formMethods.getValues(`KRAs_${kraKey}_comments`) || "";
      const artifacts = formMethods.getValues(`KRAs_${kraKey}_artifacts`);

      const formData = new FormData();
      formData.append("ReferenceId", id);
      formData.append("KRAId", kraId);
      formData.append("AppraiseeId", employeeData?.id);
      formData.append("ReviewerRole", reviewerRole);
      formData.append("KRAActualScore", parseFloat(kraActualScore));
      formData.append("KRAScore", parseFloat(kraPerformanceScores[kraId] ?? 0));
      formData.append("Comment", comment);
      if (artifacts && artifacts.length > 0) {
        artifacts.forEach((artifact) => {
          formData.append(`Artifacts`, artifact.file);
        });
      }

      const res = await onSave(formData).unwrap();
      if (res.successful) {
        toast.success(res?.statusMessage || "KRA saved successfully");
        refetch();
      }
    } catch (err) {
      toast.error("Save failed: " + (err.data?.statusMessage || err.message));
    }
  };
  const submit = async (data) => {
    try {
      const payload = {
        referenceId: id,
        isAccepted: true,
        comment: data.comment,
        selectedRecommendation: data.selectedRecommendation,
        requiresPip: true,
        isOverrideRecommendation: true,
        appraiseeId: appraiseeId,
        reviewerRole: reviewerRole,
      };
      const response = await makeComment(payload).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/management/Appraisal-Management");
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage ?? "Error approving rating scale");
    }
  };
  return (
    <PageLayout title={"Appraisal Review Details"} hasBack={true}>
      <FormProvider {...formMethods}>
        <div className={DashboardStyle.app_view_controls}></div>
        <div>
          <span className={`text-[${totalScore.colorType}] font-[600]`}>
            Total Score: {totalScore.totalAppraisalScore}/{maxScore} (
            {totalScore.totalAppraisalScore / maxScore ?? 0})%
          </span>
          <div className={DashboardStyle.view_app_components}>
            <div className="mb-4"></div>
            <Accordion
              aria-label={`Accordion 1`}
              selectionMode="single"
              defaultExpandedKeys={["1"]}
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                title={
                  <div className="flex items-center gap-5 px-5">
                    <img src={person} alt="" />{" "}
                    <span className="text-[#305F32] font-[600]">
                      EMPLOYEE PROFILE SUMMARY
                    </span>
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <MetaData data={employeeData} />
              </AccordionItem>
            </Accordion>
            {allObjectives?.map((item, index) => (
              <Accordion
                aria-label={`Accordion ${index + 1}`}
                key={index + 1}
                selectionMode="single"
                defaultExpandedKeys={["1"]}
                titleWrapper="shadow-md rounded-md border border-gray-200"
              >
                <AccordionItem
                  key={index + 1}
                  title={
                    <div className="flex items-center justify-between px-5">
                      <div className="flex items-center gap-5">
                        <img src={flag} alt="" />
                        <span className="text-[#4B664C] font-[600]">
                          OBJECTIVE: {item?.objectiveTitle}
                        </span>
                      </div>
                      <div>
                        <span className="text-[#4B664C] font-[600]">
                          Weight: {item?.objectiveWeight}%
                        </span>
                      </div>
                      <div className="w-10" />
                    </div>
                  }
                  className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                >
                  <div>
                    {item?.krAs?.map((items, kraIndex) => (
                      <Accordion
                        key={kraIndex + 1}
                        aria-label={`Accordion ${kraIndex + 1}`}
                        selectionMode="single"
                        titleWrapper="shadow-md rounded-md border border-gray-200"
                        onClick={() => {
                          setKraId(items.kraId);
                          setItem(items);
                          setKraIndex(kraIndex);
                          setObjIndex(index);
                        }}
                      >
                        <AccordionItem
                          key={kraIndex + 1}
                          title={
                            <div className="flex items-center gap-5 px-5">
                              <img src={bull} alt="" />
                              <span className="text-[#4B664C] font-[600]">
                                KRA: {items?.kraTitle}
                              </span>
                            </div>
                          }
                          className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                        >
                          <div>
                            {items.isAutoGenerated && (
                              <div className="flex items-center justify-between px-5">
                                <div />
                                <div>
                                  <p className="text-[#4B664C] font-[600]">
                                    isAutogenerated
                                  </p>
                                </div>
                              </div>
                            )}
                            <div
                              key={kraIndex + 1}
                              className="flex items-center gap-5 py-2 px-5"
                              style={{
                                display: "grid",
                                gridTemplateColumns: "180px 1fr",
                                alignItems: "center",
                                gap: "16px",
                              }}
                            >
                              <h2 className="text-[#305F32] font-[600]">
                                Title: {items.kraTitle}
                              </h2>
                              <h4 className="text-[#305F32] font-[500]">
                                Description: {items.kraDescription}
                              </h4>
                              <h2 className="text-[#305F32] font-[600]">
                                Target: {items.kraTarget}
                              </h2>
                              <h4 className="text-[#00AB09] font-[500]">
                                Score:{" "}
                                {kraPerformanceScores[items.kraId] ||
                                  items?.employeeReviewDetails?.filter(
                                    (item) => item.appraisalType === 1
                                  )?.[0]?.kraScore}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Measurement Type:{" "}
                                {MeasurementTypeFormatter(
                                  items.measurementType
                                )}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Source: {items.source}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                KRA Type: {items.kraType}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Include Self Review:{" "}
                                {items.includeSelfReview ? "Yes" : "No"}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Period Start Date:{" "}
                                {new Date(
                                  items.periodStartDate
                                ).toLocaleDateString()}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Period End Date:{" "}
                                {new Date(
                                  items.periodEndDate
                                ).toLocaleDateString()}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                Next Due Date:{" "}
                                {new Date(
                                  items.nextDueDate
                                ).toLocaleDateString()}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                SLA Due Date:{" "}
                                {new Date(
                                  items.slaDueDate
                                ).toLocaleDateString()}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                SLA Reminder Count: {items.slaReminderCount}
                              </h4>
                              <h4 className="text-[#305F32] font-[500]">
                                SLA Start Duration: {items.slaStartDuration}
                              </h4>
                            </div>
                            {/* <div className="px-5">
                              <div className={DashboardStyle.button_cage}>
                                <button
                                  width={"auto"}
                                  className={DashboardStyle?.button_cage_weight}
                                  onClick={() => {
                                    setAppraisalId(items.kraId);
                                    handleApproveModal();
                                  }}
                                  type="button"
                                >
                                  Approve
                                </button>
                                <ActionButtons
                                  width={"auto"}
                                  className={DashboardStyle?.button_cage_weight}
                                  style={{ backgroundColor: "red" }}
                                  onClick={() => {
                                    setAppraisalId(items.kraId);
                                    handleDeclineModal();
                                  }}
                                  type="button"
                                >
                                  Decline
                                </ActionButtons>
                              </div>
                            </div> */}
                            {items?.employeeReviewDetails?.map((item) => (
                              <>
                                {isPermitted && (
                                  <div className="bg-[#f9fbf7] rounded-xl border border-gray-200 p-6 w-full text-base">
                                    <AppraisalReviewDetails
                                      item={item}
                                      showDocument={true}
                                      peerReviewAffectsScore={
                                        items?.peerReviewAffectsScore
                                      }
                                      upwardReviewAffectsScore={
                                        items?.upwardReviewAffectsScore
                                      }
                                      crossReviewAffectsScore={
                                        items?.crossReviewAffectsScore
                                      }
                                    />
                                  </div>
                                )}
                              </>
                            ))}
                            <div>
                              <Content1
                                id={items.kraId}
                                objIndex={index}
                                kraIndex={kraIndex}
                                defaultValues={
                                  items?.employeeReviewDetails?.filter(
                                    (item) => item.appraisalType === 1
                                  )?.[0]
                                }
                                formMethods={formMethods}
                                items={items}
                                ratingScales={items?.ratingScales}
                              />
                              <div
                                style={{ marginTop: "1rem" }}
                                className={`flex justify-end mr-5`}
                              >
                                <ActionButtons
                                  width={"auto"}
                                  type={"button"}
                                  onClick={handleSave}
                                  className={DashboardStyle?.button_cage_weight}
                                  bg="var(--primary-color)"
                                >
                                  {isLoading ? "Saving..." : "Save"}
                                </ActionButtons>
                              </div>
                            </div>
                          </div>
                        </AccordionItem>
                      </Accordion>
                    ))}
                  </div>
                </AccordionItem>
              </Accordion>
            ))}
            <Accordion
              aria-label={`Accordion 3`}
              selectionMode="single"
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                title={
                  <div className="flex items-center gap-5 px-5">
                    <img src={person} alt="" />{" "}
                    <span className="text-[#305F32] font-[600]">
                      Comment & Recommendation
                    </span>
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <div className="my-6">
                  <FormProvider {...formMethods}>
                    <FormTemplate
                      className={"p-6"}
                      handleSubmit={handleSubmit(submit)}
                    >
                      <div className="grid grid-cols-3 gap-8">
                        <FormTextArea
                          className="h-[200px] col-span-2"
                          title={"Comment"}
                          camelCase={"comment"}
                        />
                        <FormSelect
                          title={"Recommendation"}
                          camelCase={"selectedRecommendation"}
                          placeholder={"Select Recommendation"}
                          disabled={recommendation?.result?.filter(
                            (rec) =>
                              totalScore.totalAppraisalScore >= rec.fromScore &&
                              totalScore.totalAppraisalScore <= rec.toScore
                          )}
                          array={recommendation?.result
                            ?.filter(
                              (rec) =>
                                totalScore.totalAppraisalScore >=
                                  rec.fromScore &&
                                totalScore.totalAppraisalScore <= rec.toScore
                            )
                            ?.map((opt) => (
                              <option
                                key={opt.id}
                                value={opt.recommendationTitle}
                              >
                                {opt.recommendationTitle}
                              </option>
                            ))}
                          defaultValue={
                            recommendation?.result
                            ?.filter(
                              (rec) =>
                                totalScore.totalAppraisalScore >=
                                  rec.fromScore &&
                                totalScore.totalAppraisalScore <= rec.toScore
                            )
                            ?.length === 1 ? 
                            recommendation?.result
                            ?.filter(
                              (rec) =>
                                totalScore.totalAppraisalScore >=
                                  rec.fromScore &&
                                totalScore.totalAppraisalScore <= rec.toScore
                            )?.[0]?.recommendationTitle
                            : "Select Recommendation"
                          }
                        />
                      </div>
                      <div
                        style={{ marginTop: "1rem" }}
                        className={DashboardStyle.button_cage}
                      >
                        <ActionButtons
                          isLoading={isLoading}
                          disabled={!isValid}
                          width={"auto"}
                          className={DashboardStyle?.button_cage_weight}
                          bg="var(--primary-color)"
                        >
                          {isLoading ? "Submitting..." : "Submit Review"}
                        </ActionButtons>
                      </div>
                    </FormTemplate>
                  </FormProvider>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
        {openDeclineModal && (
          <AppraisalDeclineModal
            openModal={openDeclineModal}
            closeModal={handleDeclineModal}
            handleComment={handleComment}
            handleDelete={() => declineAction(false)}
            isLoading={isLoading}
            extra={
              <div className="flex items-center gap-2">
                <StandaloneCheckBox
                  camelCase="isOverrideRecommendation"
                  checked={isOverrideRecommendation}
                  onChange={(e) =>
                    setIsOverrideRecommendation(e.target.checked)
                  }
                />
                <small>Override existing recommendations?</small>
              </div>
            }
          />
        )}
        <ApproveModal
          isOpen={openApproveModal}
          handleClose={handleApproveModal}
          handleDelete={() => declineAction(true)}
          isLoading={isLoading}
          hasComment={true}
          disabled={!comment}
          // comment={
          //   <div
          //     className="flex items-start justify-between gap-3 w-full px-7 py-7"
          //     style={{ borderBottom: "1px solid #ccc" }}
          //   >
          //     <textarea
          //       cols={"15"}
          //       rows={"5"}
          //       placeholder="Enter a comment..."
          //       onChange={handleComment}
          //       className="text-xs border border-slate-300 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
          //     />
          //   </div>
          // }
          headText={"Approve Appraisal"}
          extra={
            <div className="flex items-center gap-2">
              <StandaloneCheckBox
                camelCase="isOverrideRecommendation"
                checked={isOverrideRecommendation}
                onChange={(e) => setIsOverrideRecommendation(e.target.checked)}
              />
              <small>Override existing recommendations?</small>
            </div>
          }
        />
      </FormProvider>
    </PageLayout>
  );
};
